import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const EducationalPreview = () => {
  const courses = [
  {
    title: "Cryptocurrency Fundamentals",
    description: "Learn the basics of blockchain technology, digital wallets, and how cryptocurrencies work in simple, easy-to-understand terms.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f16da186-1768146282473.png",
    imageAlt: "Digital illustration of cryptocurrency blockchain network with glowing blue and gold connections representing decentralized technology on dark background",
    duration: "2 hours",
    level: "Beginner",
    icon: "BookOpen"
  },
  {
    title: "Investment Strategies",
    description: "Discover proven strategies for building a diversified crypto portfolio, managing risk, and making informed investment decisions.",
    image: "https://images.unsplash.com/photo-1583373325529-501e03a3a8e7",
    imageAlt: "Professional financial charts and graphs displayed on computer screens showing cryptocurrency market analysis with green and red candlestick patterns",
    duration: "3 hours",
    level: "Intermediate",
    icon: "TrendingUp"
  },
  {
    title: "Security Best Practices",
    description: "Master essential security measures to protect your digital assets, including two-factor authentication, cold storage, and threat prevention.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13443a0fe-1766507333666.png",
    imageAlt: "Futuristic digital security interface with glowing blue lock icon and encrypted data streams representing cybersecurity protection in dark environment",
    duration: "1.5 hours",
    level: "All Levels",
    icon: "Shield"
  }];


  return (
    <section className="py-12 md:py-16 lg:py-24 bg-[var(--color-background)]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[var(--color-secondary)]/10 px-4 py-2 rounded-full mb-4">
            <Icon name="GraduationCap" size={20} color="var(--color-secondary)" />
            <span className="text-sm font-medium text-[var(--color-secondary)]">Educational Resources</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-4">
            Learn Before You Invest
          </h2>
          <p className="text-base md:text-lg text-[var(--color-muted-foreground)] max-w-3xl mx-auto">
            Access our comprehensive learning center designed to help you make informed investment decisions with confidence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-8 md:mb-12">
          {courses?.map((course, index) =>
          <div
            key={index}
            className="bg-[var(--color-card)] rounded-xl overflow-hidden border border-[var(--color-border)] hover:shadow-lg transition-shadow duration-300">

              <div className="relative h-48 md:h-56 overflow-hidden">
                <Image
                src={course?.image}
                alt={course?.imageAlt}
                className="w-full h-full object-cover" />

                <div className="absolute top-4 right-4 bg-[var(--color-card)] px-3 py-1 rounded-full">
                  <span className="text-xs font-medium text-[var(--color-foreground)]">{course?.level}</span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <Icon name={course?.icon} size={20} color="var(--color-primary)" />
                  <h3 className="text-lg md:text-xl font-semibold text-[var(--color-foreground)]">
                    {course?.title}
                  </h3>
                </div>

                <p className="text-sm md:text-base text-[var(--color-muted-foreground)] mb-4 line-clamp-3">
                  {course?.description}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-[var(--color-border)]">
                  <div className="flex items-center gap-2">
                    <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
                    <span className="text-sm text-[var(--color-muted-foreground)]">{course?.duration}</span>
                  </div>
                  <button className="text-sm font-medium text-[var(--color-primary)] hover:underline">
                    Start Learning
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="text-center">
          <Button
            variant="outline"
            size="lg"
            iconName="ArrowRight"
            iconPosition="right">

            Explore All Courses
          </Button>
        </div>
      </div>
    </section>);

};

export default EducationalPreview;